import {NgModule} from '@angular/core';

import {HeightBasedSquareComponent} from './height-square.component';

@NgModule({
  declarations: [HeightBasedSquareComponent],
  exports: [HeightBasedSquareComponent],
})
export class SquaresModule {}
